import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import IggloProgressBar from '../../../common/IggloProgressBar';
import tr from '../../../localization/translate';

import s from './RemainingTimeCircle.scss';

const msInSeconds = 1000;
const msInMinutes = 1000 * 60;
const msInHours = msInMinutes * 60;
const msInDays = msInHours * 24;

class RemainingTimeCircle extends PureComponent {
  static diffTime(props) {
    const rawDiff = props.to.valueOf() - moment.utc().valueOf();
    const diff = (rawDiff > 0) ? rawDiff : 0;

    const days = diff / msInDays;
    if (days > 1) {
      return { unit: msInDays, speed: (days >= 2) ? msInDays : msInHours, diff: days };
    }

    const hours = diff / msInHours;
    if (hours > 1) {
      return { unit: msInHours, speed: (hours >= 2) ? msInHours : msInMinutes, diff: days };
    }

    const minutes = diff / msInMinutes;
    if (minutes > 1) {
      return {
        unit: msInMinutes,
        speed: (minutes >= 2) ? msInMinutes : msInSeconds,
        diff: minutes
      };
    }

    if (diff > 0) {
      return { unit: msInSeconds, speed: msInSeconds, diff: diff / msInSeconds };
    }

    return { unit: msInSeconds, speed: 0, diff };
  }

  static remainingTimePercentage(props) {
    const { from, to } = props;
    const p = (to.valueOf() - moment.utc().valueOf()) / (to.valueOf() - from.valueOf());

    return (p > 0) ? p : 0;
  }

  static remainingTimeText(diff) {
    const params = { count: Math.ceil(diff.diff) };

    switch (diff.unit) {
      case msInDays: return tr('matching.about_search.remaining_time.days', params);
      case msInHours: return tr('matching.about_search.remaining_time.hours', params);
      case msInMinutes: return tr('matching.about_search.remaining_time.minutes', params);
      default: return tr('matching.about_search.remaining_time.seconds', params);
    }
  }

  constructor(props) {
    super(props);

    this.update = this.update.bind(this);

    this.state = RemainingTimeCircle.getDerivedStateFromProps(props);

    this.lastTimeStamp = 0;
    this.rafId = null;
  }

  static getDerivedStateFromProps(nextProps) {
    const diff = RemainingTimeCircle.diffTime(nextProps);

    return {
      percentage: RemainingTimeCircle.remainingTimePercentage(nextProps),
      text: RemainingTimeCircle.remainingTimeText(diff),
      speed: diff.speed
    };
  }

  componentDidMount() {
    this.rafId = window.requestAnimationFrame(this.update);
  }

  componentDidUpdate() {
    if (!this.rafId) {
      this.rafId = window.requestAnimationFrame(this.update);
    }
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(this.rafId);
  }

  update(time) {
    if (time - this.lastTimeStamp >= this.state.speed) {
      this.setState(RemainingTimeCircle.getDerivedStateFromProps(this.props));
      this.lastTimeStamp = time;
    }

    this.rafId = (this.state.speed !== 0) ? window.requestAnimationFrame(this.update) : null;
  }


  render() {
    return (
      <IggloProgressBar
        styleName="container"
        childContainerClassName={s.progressBarText}
        progress={this.state.percentage}
        duration={220}
        strokeWidth={6}
        trailWidth={9}
        initialAnimate
      >
        <p
          className="orator rem_1 center white"
          dangerouslySetInnerHTML={{ __html: this.state.text.toLowerCase() }} // eslint-disable-line
        />
      </IggloProgressBar>
    );
  }
}

RemainingTimeCircle.propTypes = {
  from: PropTypes.instanceOf(moment).isRequired, // eslint-disable-line react/no-unused-prop-types
  to: PropTypes.instanceOf(moment).isRequired // eslint-disable-line react/no-unused-prop-types
};

export default RemainingTimeCircle;
